export default __webpack_public_path__ + "static/media/Windy2.b2fc61f7.jpg";